import type { SVGProps } from "react";

/**
 * Wordmark — "NEXIRT" in Clash Display Semibold 600, tracking -0.015em,
 * all caps. Rendered as <text> with currentColor fill — inherits from parent.
 *
 * Minimum height: 16px. Below that, use mark-only.
 * Source of truth: tasks/BRAND_IDENTITY.md §5.
 */

type Props = Omit<SVGProps<SVGSVGElement>, "viewBox"> & { height?: number };

export function Wordmark({ height = 24, ...props }: Props) {
  return (
    <svg
      viewBox="0 0 260 64"
      height={height}
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label="NEXIRT"
      {...props}
    >
      <text
        x="0"
        y="48"
        fontFamily='"Clash Display", "Satoshi", "Inter Variable", "SF Pro Display", system-ui, sans-serif'
        fontSize="52"
        fontWeight="600"
        style={{ letterSpacing: "-0.015em" }}
        fill="currentColor"
      >
        NEXIRT
      </text>
    </svg>
  );
}
